import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  return (
    <section className="relative h-[85vh] w-full bg-zinc-900 flex items-center">
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat opacity-60"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1522163182402-834f871fd851?auto=format&fit=crop&w=2000&q=80')" }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/80 to-transparent z-10" />
      
      <div className="relative z-20 max-w-7xl mx-auto px-4 w-full">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <div className="inline-block bg-orange-600 text-white text-xs font-bold uppercase tracking-widest px-3 py-1 mb-6 border border-orange-500">
            Tested in Patagonia
          </div>
          <h1 className="text-6xl md:text-8xl font-black uppercase tracking-tighter leading-[0.9] mb-6 drop-shadow-lg">
            Gear For The <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-orange-700">Unforgiving</span>
          </h1>
          <p className="text-xl text-zinc-300 max-w-xl font-medium mb-10 border-l-4 border-orange-600 pl-4">
            Military-grade materials. Alpine-tested durability. We build equipment for those who push past the tree line.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button className="bg-orange-600 hover:bg-orange-500 text-white font-black uppercase tracking-widest px-8 py-4 flex items-center justify-center gap-3 transition-colors border border-orange-400">
              Shop Fall Collection
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </button>
            <button className="bg-zinc-900/50 hover:bg-zinc-800 text-white font-bold uppercase tracking-widest px-8 py-4 border-2 border-zinc-500 hover:border-zinc-300 backdrop-blur-sm transition-colors">
              View Specs
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;